import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SnackbarTypeEnum } from './SnackbarTypeEnum';

export interface SnackbarState {
  type: SnackbarTypeEnum;
  body: string;
  autoHideDuration: number | undefined;
}

const initialState: SnackbarState = {
  type: SnackbarTypeEnum.NONE,
  body: '',
  autoHideDuration: undefined,
};

const dynamicSnackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    open: (state: SnackbarState, action: PayloadAction<SnackbarState>) => {
      state.type = action.payload.type;
      state.body = action.payload.body;
      state.autoHideDuration = action.payload.autoHideDuration;
    },
    close: () => initialState,
  },
});

export default dynamicSnackbarSlice;
